import { Action, ActionType, Flags } from "../types";

export function flags(
  state: Flags = {
    MULTIPLE_USERS_DISCLAIMER_MODAL_SHOWN: false,
    SETTINGS_MODAL_OPEN: false,
    USER_GUIDE_MODAL_OPEN: false,
  },
  action: Action
): Flags {
  switch (action.type) {
    case ActionType.TOGGLE_FLAG:
      return {
        ...state,
        [action.name]:
          action.value === undefined ? !state[action.name] : action.value,
      };
    default:
      return state;
  }
}
